<template>
    <div id="pw">
     <div class="dokpz">
        <div class="title">{{ title }}</div>
	<div class="items">
     		<ejs-grid ref="grid" :dataSource="data" :allowPaging="true" :pageSettings="pageSettings" :allowSorting="true" :allowGrouping="false" :selectionSettings="selectionOptions" :rowSelected="rowSelected" :rowDeselected="rowSelected" :allowTextWrap='true' locale='pl-PL' :rowHeight="80"> 
			<e-columns>
				<e-column field='ID_DOK_MAGAZYNOWEGO' headerText='ID' :visible="false"></e-column>
                                <e-column field='numerPW' headerText='Numer PW' width='140'></e-column>
                                <e-column field='dataPW' headerText='Data PW' type='date' format='yyyy-MM-dd' width='110'></e-column>
                                <e-column field='nazwaKontrahenta' headerText='Nazwa kontrahenta' width='200'></e-column>
                                <e-column field='nazwaArtykulu' headerText='Nazwa artykułu' width='100'></e-column>
                                <e-column field='waga' headerText='Waga' width='80'></e-column>
                                <e-column field='iloscArtykulu' headerText='Ilość artykułu' width='100'></e-column>
                                <e-column field='iloscSkrzyn' headerText='Ilość opakowań' width='100'></e-column>
                                <!--<e-column type='checkbox' width='50'></e-column>-->
			</e-columns>
		</ejs-grid>
     		<div class="drukuj">
			<button> DRUKUJ ETYKIETĘ </button>
     		</div>
	</div>
     </div>
     <div class="wroc">
	<button id="wroc"> WRÓĆ </button>
     </div>
    </div>
</template>

<script>

import Vue from "vue";
import { GridPlugin, Page, Sort, Filter, Group } from "@syncfusion/ej2-vue-grids";
import { dokumenty_pw } from "./dokumentpw_dane.js";
import * as CONFIG from "./config.js";
import axios from "axios";
import { polish } from "./polish.js";
import Storage from "./Storage";

axios.defaults.withCredentials = false;

Vue.use(GridPlugin);

export default {
  name: "dokumentypw",
  props: {
    groupTitle: String,
    dataLoading: Boolean,
  },
  data: () => ({
	//data: dokumenty_pw.items,
	data: [],
        url: "/agent/GALEK.Magazyn/GetDokumentPW",
	title: "LISTA DOKUMENTÓW PW",
	x: 1,
        pageSettings: { pageSize: 5 },
        selectionOptions: { allowColumnSelection: false, type: 'Single' },
	gitem: { },
	jwt: "",
        id_zlecenia: 0,
   }),
   provide: {
	grid: [Page, Sort, Filter, Group]
   },
   methods: { 
	rowSelected(args) {
                let selectedrecords = this.$refs.grid.getSelectedRecords();  // Get the selected records.
                if (selectedrecords.length > 0) {
                        this.gitem = selectedrecords[0];                
                        //alert(JSON.stringify(this.gitem));
                } else {
                        this.gitem = {};
                }
        },
	drukujclick() {
		//alert("Drukuj");
		//this.$router.push({ path: "/etykieta" });
		if (this.gitem && this.gitem.ID_DOK_MAGAZYNOWEGO) {
                        this.$router.push({ path: "/etykietapw", query: { item: this.gitem.ID_DOK_MAGAZYNOWEGO }});
                } else {
                        alert("Nie wybrano elementu do druku. Proszę zaznaczyć dokładnie 1 element z listy.");
                }
	},
	wrocclick() {
		this.$router.push({ path: "/main" });
	},
	getData() {
                return axios
                        .get(CONFIG.API_URL + this.url + "?id_zlecenia=" + this.id_zlecenia, {
                        headers: {
                                "Content-Type": "application/x-www-form-urlencoded",
                                "Accept": "application/json",
				"Authorization": "Bearer " +  this.jwt,
                        }
                        })
                        .then(response => {
                                return response.data;
                        })
                        .catch(e => {
                                alert("ERROR" + e);
                        });
        },
   },
   mounted() {
        var params = this.$route.query;
        if (params["id_zlecenia"]) {
                this.id_zlecenia = params["id_zlecenia"];
        }
	var that = this;
	Storage.loadJWT("jwt").then(resp => {
                that.jwt = resp.access_token;
                that.getData().then(data => {
                        that.data = data;
                });
        });
	document.querySelector(".drukuj").addEventListener('click', function() { that.drukujclick(); } );
	document.querySelector(".wroc").addEventListener('click', function() { that.wrocclick(); } );
   }
};

</script>

<style>
  @import "../../node_modules/@syncfusion/ej2-vue-grids/styles/material.css";

.wroc {
	width: 100%;
	height: 10%;
	text-align: right;
	float: left;
}

.drukuj {
	width: 100px;
	height: 50px;
	padding-top: 10px;
	text-align: right;
	float: right;
}

.title {
        text-align: left;
        width: 50%;
}
.items {
        float:none;
}
.dokpz {
        float: left;
        width: 96%;
        padding: 2% 2% 0% 2%;
}
.wroc {
        width: 200px;
        height: 50px;
        position:relative;
        text-align: left;
        background-color: #FFFFFF;
        float: left;
        margin-top: 40px;
        margin-left: 400px;
}
#wroc {
        width: 200px;
        height: 50px;
        position:relative;
        background-color: #FFFFFF;
}

</style>



// WEBPACK FOOTER //
// src/components/DokumentPW.vue